export default function (_, inject) {
  const smartCaptchaReady = new Promise((resolve) => {
    if (process.client) {
      window.onSmartCaptchaLoad = function () {
        resolve(window.smartCaptcha)
      }
      const script = document.createElement('script')
      script.src =
        'https://smartcaptcha.yandexcloud.net/captcha.js?render=onload&onload=onSmartCaptchaLoad'
      script.async = true
      document.head.appendChild(script)
    }
  })

  inject('smartCaptchaReady', smartCaptchaReady)
}
